import { render, staticRenderFns } from "./MiniWizardStickyBacker.vue?vue&type=template&id=b11848a8&"
import script from "./MiniWizardStickyBacker.vue?vue&type=script&lang=js&"
export * from "./MiniWizardStickyBacker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports